import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from 'src/app/Compliance/WeissmanModalService';
import { PaymentBatchPaymentsBulkUpdateOutcome } from './paymentBatchPaymentsBulkUpdate.service';

@Component({
    selector: 'payment-batch-payments-bulk-update-result-modal',
    templateUrl: './paymentBatchPaymentsBulkUpdateResultModal.component.html',
    standalone: false,
})
export class PaymentBatchPaymentsBulkUpdateResultModalComponent
    implements IWeissmanModalComponent<{ outcome: PaymentBatchPaymentsBulkUpdateOutcome }, void>
{
    constructor(private readonly bsModalRef: BsModalRef) {}
    params: { outcome: PaymentBatchPaymentsBulkUpdateOutcome };
    result: void;

    get approverFailures(): Core.PaymentBatchBulkUpdateApproverFailureModel[] {
        return this.params.outcome.approver.result?.failures ?? [];
    }

    close(): void {
        this.bsModalRef.hide();
    }
}
